const technicalEvents = [
	{
		img: "/assets/csgo.webp",
		title: "Counter-Strike: Global Offensive",
		subtitle:
			"'Let's go, fellas.' 'Let's move out.' We invite you and your squad to come and play. You are allowed to carry your equipments such as mouse-pad, headphones for better experience and good game.",
		registerLink:
			"https://docs.google.com/forms/d/e/1FAIpQLSfBc-4ACA4vOhthQcf5PFueZT1HdoJokgMvMsM0oYOetK694w/viewform",
	},
	{
		img: "/assets/valo.webp",
		title: "Valorant",
		subtitle:
			"'One shot one kill, No luck only skill.' We invite you and your squad to come and play. You have to use your mobile network.",
		registerLink:
			"https://docs.google.com/forms/d/e/1FAIpQLSfBc-4ACA4vOhthQcf5PFueZT1HdoJokgMvMsM0oYOetK694w/viewform",
	},
];

export default technicalEvents;
